import { Phone, Mail, MapPin, Clock, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { FadeUp } from "./Reveal";

const ITEMS = [
  {
    Icon: Phone,
    label: "Call or Text",
    value: BRAND.phone,
    href: `tel:${BRAND.phoneRaw}`,
    testid: "contact-phone",
  },
  {
    Icon: Mail,
    label: "Email",
    value: BRAND.email,
    href: `mailto:${BRAND.email}`,
    testid: "contact-email",
  },
  {
    Icon: MapPin,
    label: "Service Area",
    value: BRAND.city + " & surrounding",
    href: null,
    testid: "contact-area",
  },
  {
    Icon: Clock,
    label: "Hours",
    value: BRAND.hours,
    href: null,
    testid: "contact-hours",
  },
];

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-28 md:py-40 bg-[#F5F3EE] text-[#111613]"
    >
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
        <FadeUp>
          <div className="text-center max-w-4xl mx-auto mb-16 md:mb-20">
            <div className="chapter-line text-[#0E2A1A] mb-6 justify-center">
              Ch. 07 · Get in touch
            </div>
            <h2
              className="font-display text-[#0E2A1A] text-6xl sm:text-7xl md:text-8xl lg:text-9xl leading-[0.92] tracking-[-0.03em]"
              style={{ fontWeight: 400 }}
            >
              Ready when{" "}
              <span className="italic text-[#DA7B3C]">you are.</span>
            </h2>
            <p className="text-lg md:text-xl mt-8 text-[#111613]/70 max-w-2xl mx-auto">
              {"Call, text, or send a quote request. Whichever's easiest — we'll get back fast."}
            </p>
          </div>
        </FadeUp>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0 border-t border-[#111613]/20">
          {ITEMS.map(({ Icon, label, value, href, testid }, idx) => {
            const Tag = href ? "a" : "div";
            return (
              <FadeUp key={label} delay={idx * 0.08}>
                <Tag
                  {...(href ? { href } : {})}
                  data-testid={testid}
                  className={`group block p-8 md:p-10 h-full border-b sm:border-b-0 border-[#111613]/20 ${
                    idx !== ITEMS.length - 1 ? "sm:border-r" : ""
                  } ${href ? "hover:bg-[#0E2A1A] hover:text-[#FFFFFF]" : ""} transition-colors duration-500`}
                >
                  <div className="flex items-start justify-between mb-8">
                    <Icon
                      className="w-5 h-5 opacity-60 group-hover:opacity-100"
                      strokeWidth={1.75}
                    />
                    {href && (
                      <ArrowUpRight
                        className="w-4 h-4 opacity-40 group-hover:opacity-100 group-hover:rotate-12 transition-all"
                        strokeWidth={2}
                      />
                    )}
                  </div>
                  <div className="font-mono-sm opacity-60 mb-3">{label}</div>
                  <div
                    className="font-display text-2xl md:text-3xl tracking-[-0.02em] break-words leading-tight"
                    style={{ fontWeight: 400 }}
                  >
                    {value}
                  </div>
                </Tag>
              </FadeUp>
            );
          })}
        </div>

        <FadeUp delay={0.2}>
          <div className="mt-16 md:mt-20 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={`tel:${BRAND.phoneRaw}`}
              data-testid="contact-cta-call"
              className="btn-primary"
            >
              <Phone className="w-4 h-4" strokeWidth={2} /> Call {BRAND.phone}
            </a>
            <a
              href="#quote"
              data-testid="contact-cta-quote"
              className="btn-ghost"
            >
              Get A Free Quote
              <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
            </a>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
